/* ═══════════════════════════════════════════════════════════════════════
   IBERIAN 3D STUDIO · Inicio v4
   Menú móvil, pestañas accesibles, galería de proyectos, reflejo del vidrio
   e inclinación del hero. Sin listeners de scroll: estado de la galería con
   IntersectionObserver; todo el movimiento respeta prefers-reduced-motion.
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var finePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  function safe(fn, name) {
    try { fn(); } catch (e) { console.warn("[I3D home:" + name + "]", e); }
  }

  /* ─── Menú móvil ─────────────────────────────────────────────────────── */
  function initNavSheet() {
    var toggle = document.querySelector(".h-nav-toggle");
    var sheet = document.getElementById("navSheet");
    if (!toggle || !sheet) return;

    function setOpen(open) {
      sheet.hidden = !open;
      toggle.setAttribute("aria-expanded", String(open));
      toggle.setAttribute("aria-label", open ? "Cerrar menú" : "Abrir menú");
      var icon = toggle.querySelector("i");
      if (icon) icon.className = open ? "ph ph-x" : "ph ph-list";
    }
    toggle.addEventListener("click", function () { setOpen(sheet.hidden); });
    sheet.addEventListener("click", function (e) { if (e.target.closest("a")) setOpen(false); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !sheet.hidden) { setOpen(false); toggle.focus(); }
    });
  }

  /* ─── Pestañas (patrón WAI-ARIA, flechas para moverse) ──────────────── */
  function activateTab(list, tab, focus) {
    var tabs = list.querySelectorAll('[role="tab"]');
    tabs.forEach(function (t) {
      var selected = t === tab;
      t.setAttribute("aria-selected", String(selected));
      t.tabIndex = selected ? 0 : -1;
      var panel = document.getElementById(t.getAttribute("aria-controls"));
      if (panel) panel.hidden = !selected;
    });
    if (focus) tab.focus();
  }

  function initTabs() {
    document.querySelectorAll("[data-tabs]").forEach(function (list) {
      var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
      list.addEventListener("click", function (e) {
        var tab = e.target.closest('[role="tab"]');
        if (tab) activateTab(list, tab, false);
      });
      list.addEventListener("keydown", function (e) {
        var i = tabs.indexOf(document.activeElement);
        if (i < 0) return;
        var next = null;
        if (e.key === "ArrowRight") next = tabs[(i + 1) % tabs.length];
        if (e.key === "ArrowLeft") next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === "Home") next = tabs[0];
        if (e.key === "End") next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); activateTab(list, next, true); }
      });
    });
  }

  /* ─── Presupuesto: #personalizado / #empresas y formulario recién enviado ─ */
  function initQuoteTabs() {
    var list = document.querySelector("[data-hash-tabs]");
    if (!list) return;

    function fromHash() {
      var hash = window.location.hash.replace("#", "");
      var tab = list.querySelector('[data-hash="' + hash + '"]');
      if (tab) {
        activateTab(list, tab, false);
        var section = document.getElementById("presupuesto");
        if (section) section.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
      }
    }

    var posted = document.querySelector("[data-quote-active]");
    if (posted) {
      var panel = posted.closest('[role="tabpanel"]');
      var tab = panel && list.querySelector('[aria-controls="' + panel.id + '"]');
      if (tab) activateTab(list, tab, false);
    } else {
      fromHash();
    }
    window.addEventListener("hashchange", fromHash);
  }

  /* ─── Galería de proyectos ──────────────────────────────────────────── */
  function initProjects() {
    var track = document.getElementById("projectsTrack");
    var prev = document.querySelector("[data-scroll-prev]");
    var next = document.querySelector("[data-scroll-next]");
    if (!track || !prev || !next) return;

    var items = track.children;
    function step(dir) {
      var card = items[0];
      var amount = card ? card.getBoundingClientRect().width + 16 : 320;
      track.scrollBy({ left: dir * amount, behavior: reduceMotion ? "auto" : "smooth" });
    }
    prev.addEventListener("click", function () { step(-1); });
    next.addEventListener("click", function () { step(1); });

    if (!items.length || !("IntersectionObserver" in window)) return;
    var first = items[0];
    var last = items[items.length - 1];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var fully = entry.intersectionRatio > 0.95;
        if (entry.target === first) prev.disabled = fully;
        if (entry.target === last) next.disabled = fully;
      });
    }, { root: track, threshold: [0, 0.95, 1] });
    io.observe(first);
    io.observe(last);
  }

  /* ─── Reflejo del vidrio que sigue al puntero ───────────────────────── */
  function initSpotlight() {
    if (!finePointer) return;
    document.querySelectorAll("[data-spotlight]").forEach(function (el) {
      var frame = 0;
      el.addEventListener("pointermove", function (e) {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          var r = el.getBoundingClientRect();
          el.style.setProperty("--mx", (e.clientX - r.left) + "px");
          el.style.setProperty("--my", (e.clientY - r.top) + "px");
          frame = 0;
        });
      });
    });
  }

  /* ─── Inclinación del hero (muestra el volumen de la pieza) ─────────── */
  function initTilt() {
    if (reduceMotion || !finePointer) return;
    var stage = document.querySelector("[data-tilt]");
    if (!stage) return;
    var frame = 0;
    stage.addEventListener("pointermove", function (e) {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        var r = stage.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        stage.style.setProperty("--ry", (x * 8).toFixed(2) + "deg");
        stage.style.setProperty("--rx", (-y * 6).toFixed(2) + "deg");
        frame = 0;
      });
    });
    stage.addEventListener("pointerleave", function () {
      stage.style.setProperty("--ry", "0deg");
      stage.style.setProperty("--rx", "0deg");
    });
  }

  /* ─── Reseñas: abrir/cerrar formulario ──────────────────────────────── */
  function initReviewForm() {
    var toggle = document.getElementById("reviewToggle");
    var box = document.getElementById("reviewFormBox");
    if (!toggle || !box) return;
    function setOpen(open) {
      box.hidden = !open;
      toggle.setAttribute("aria-expanded", String(open));
    }
    toggle.addEventListener("click", function () {
      var open = box.hidden;
      setOpen(open);
      if (open) box.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "center" });
    });
    if (box.querySelector("[data-review-open]")) setOpen(true);
  }

  /* ─── Colabora: abrir si el formulario se acaba de enviar ───────────── */
  function initCollab() {
    var details = document.querySelector("[data-collab]");
    if (details && details.querySelector(".h-msg")) details.open = true;
  }

  /* ─── Producto personalizable: galería de fotos ─────────────────────── */
  function initGallery() {
    var main = document.getElementById("pdpMainImg");
    var thumbs = document.querySelectorAll("[data-pdp-thumb]");
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (btn) {
      btn.addEventListener("click", function () {
        thumbs.forEach(function (b) { b.setAttribute("aria-pressed", String(b === btn)); });
        if (main.getAttribute("src") === btn.dataset.src) return;
        main.classList.add("is-swapping");
        var next = new Image();
        next.onload = next.onerror = function () {
          main.src = btn.dataset.src;
          main.alt = btn.dataset.alt || "";
          main.classList.remove("is-swapping");
        };
        next.src = btn.dataset.src;
      });
    });
  }

  /* ─── Producto personalizable: archivos, enlace NFC y envío ─────────── */
  var MAX_FILE_MB = 20;
  var TOO_BIG = "El archivo pesa más de " + MAX_FILE_MB + " MB. Prueba con uno más ligero o envíalo a iberian3dstudiopromotions@gmail.com.";

  function isTooBig(input) {
    var file = input.files && input.files[0];
    return !!file && file.size > MAX_FILE_MB * 1024 * 1024;
  }

  function initCustomForm() {
    var form = document.getElementById("customForm");
    if (!form) return;
    var error = form.querySelector("[data-custom-error]");
    var submit = form.querySelector("[data-custom-submit]");
    var submitHtml = submit ? submit.innerHTML : "";
    var fileInputs = form.querySelectorAll("[data-file-input]");

    function showError(msg) {
      if (!error) return;
      error.textContent = msg;
      error.hidden = !msg;
    }

    fileInputs.forEach(function (input) {
      var box = input.closest(".h-file");
      var name = box.querySelector("[data-file-name]");
      var emptyText = name.textContent;
      input.addEventListener("change", function () {
        var file = input.files && input.files[0];
        box.classList.toggle("has-file", !!file);
        name.textContent = file ? file.name : emptyText;
        showError(isTooBig(input) ? TOO_BIG : "");
      });
      ["dragenter", "dragover"].forEach(function (t) {
        input.addEventListener(t, function () { box.classList.add("is-dragover"); });
      });
      ["dragleave", "drop"].forEach(function (t) {
        input.addEventListener(t, function () { box.classList.remove("is-dragover"); });
      });
    });

    form.addEventListener("submit", function (e) {
      if (Array.prototype.some.call(fileInputs, isTooBig)) {
        e.preventDefault();
        showError(TOO_BIG);
        return;
      }
      // Enlace del NFC: si el cliente escribe "www.web.com", se guarda como https://www.web.com
      form.querySelectorAll("[data-url-field]").forEach(function (field) {
        var value = field.value.trim();
        if (value && !/^[a-z][a-z0-9+.-]*:/i.test(value)) field.value = "https://" + value;
      });
      showError("");
      if (submit) {
        submit.classList.add("is-loading");
        submit.textContent = fileInputs.length ? "Subiendo archivo…" : "Añadiendo…";
      }
    });

    // Al volver atrás desde el carrito, el botón no debe quedarse en "Subiendo…"
    window.addEventListener("pageshow", function () {
      if (!submit) return;
      submit.classList.remove("is-loading");
      submit.innerHTML = submitHtml;
    });
  }

  /* ─── Carrito: contador, aviso y añadir por AJAX (toda la tienda) ───── */
  function cartBadge(n) {
    var b = document.getElementById("cart-count");
    if (!b) return;
    b.textContent = n;
    b.style.display = n > 0 ? "flex" : "none";
    b.classList.remove("is-pop");
    void b.offsetWidth; // reinicia la animación
    b.classList.add("is-pop");
  }
  function toast(text) {
    var t = document.getElementById("cart-toast");
    if (!t) return;
    t.textContent = text;
    t.classList.add("is-visible");
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove("is-visible"); }, 2400);
  }
  function addToCart(variantId, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    }).then(function (r) {
      if (!r.ok) throw new Error("cart/add " + r.status);
      return fetch("/cart.js");
    }).then(function (r) { return r.json(); });
  }
  function initCartAjax() {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) { cartBadge(c.item_count); }).catch(function () {});
    document.addEventListener("click", function (e) {
      var btn = e.target.closest(".btn-add-cart");
      if (!btn || !btn.dataset.handle) return;
      var handle = btn.dataset.handle, label = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Añadiendo…";
      fetch("/products/" + handle + ".js")
        .then(function (r) { return r.json(); })
        .then(function (p) { return addToCart(p.variants[0].id, 1); })
        .then(function (c) {
          cartBadge(c.item_count);
          var card = btn.closest("[data-handle]");
          var name = card && card.querySelector(".card-name") ? card.querySelector(".card-name").textContent.trim() : handle;
          toast(name + " añadido al carrito");
          btn.textContent = "Añadido";
          btn.classList.add("added");
          setTimeout(function () { btn.textContent = label; btn.classList.remove("added"); btn.disabled = false; }, 1800);
        })
        .catch(function () {
          toast("No se pudo añadir. Inténtalo de nuevo.");
          btn.textContent = label;
          btn.disabled = false;
        });
    });
  }

  /* ─── Producto estándar: variantes, cantidad y compra ───────────────── */
  function initStandardProduct() {
    var root = document.querySelector("[data-pdp-standard]");
    if (!root) return;
    var atc = root.querySelector("[data-atc]");
    var priceEl = root.querySelector("[data-price]");
    var compareEl = root.querySelector("[data-compare]");
    var nameEl = root.querySelector("[data-variant-name]");
    var qtyEl = root.querySelector("[data-qty]");
    var qty = 1;
    var atcHtml = atc ? atc.innerHTML : "";

    root.querySelectorAll("[data-variant-btn]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        root.querySelectorAll("[data-variant-btn]").forEach(function (b) { b.setAttribute("aria-pressed", String(b === btn)); });
        if (nameEl) nameEl.textContent = btn.dataset.variantTitle;
        if (priceEl) priceEl.textContent = btn.dataset.variantPrice;
        if (compareEl) { compareEl.textContent = btn.dataset.variantCompare || ""; compareEl.hidden = !btn.dataset.variantCompare; }
        if (!atc) return;
        atc.dataset.variant = btn.dataset.variantId;
        var available = btn.dataset.variantAvailable !== "false";
        atc.disabled = !available;
        atc.innerHTML = available ? atcHtml : "Agotado";
      });
    });

    var minus = root.querySelector("[data-qty-minus]"), plus = root.querySelector("[data-qty-plus]");
    if (minus) minus.addEventListener("click", function () { if (qty > 1) { qty--; qtyEl.textContent = qty; } });
    if (plus) plus.addEventListener("click", function () { if (qty < 10) { qty++; qtyEl.textContent = qty; } });

    if (atc) {
      atc.addEventListener("click", function () {
        var id = parseInt(atc.dataset.variant, 10);
        if (!id) return;
        atc.disabled = true;
        atc.classList.add("is-loading");
        atc.textContent = "Añadiendo…";
        addToCart(id, qty).then(function (c) {
          cartBadge(c.item_count);
          toast((atc.dataset.title || "Producto") + " añadido al carrito");
          atc.classList.remove("is-loading");
          atc.classList.add("is-added");
          atc.textContent = "Añadido";
          setTimeout(function () { atc.classList.remove("is-added"); atc.innerHTML = atcHtml; atc.disabled = false; }, 1800);
        }).catch(function () {
          toast("No se pudo añadir. Inténtalo de nuevo.");
          atc.classList.remove("is-loading");
          atc.innerHTML = atcHtml;
          atc.disabled = false;
        });
      });
    }

    var buyNow = root.querySelector("[data-buy-now]");
    if (buyNow && atc) {
      buyNow.addEventListener("click", function (e) {
        e.preventDefault();
        var id = parseInt(atc.dataset.variant, 10);
        if (!id) { window.location.href = "/checkout"; return; }
        addToCart(id, qty).then(function () { window.location.href = "/checkout"; })
          .catch(function () { window.location.href = buyNow.getAttribute("href"); });
      });
    }
  }

  function boot() {
    safe(initCartAjax, "cart");
    safe(initStandardProduct, "pdp");
    safe(initGallery, "gallery");
    safe(initCustomForm, "custom-form");
    safe(initNavSheet, "nav");
    safe(initTabs, "tabs");
    safe(initQuoteTabs, "quote");
    safe(initProjects, "projects");
    safe(initSpotlight, "spotlight");
    safe(initTilt, "tilt");
    safe(initReviewForm, "reviews");
    safe(initCollab, "collab");
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
